// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__1eyJL","icon":"link_icon__1KNV9","linkContent":"link_linkContent__3C2gO"};